import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { professionsToolTable, tableMenuItems } from "../../adminData";
import {
  CheckCircleIcon,
  XMarkIcon,
  PencilSquareIcon,
} from "@heroicons/react/24/outline";
import CreditRequestSvg from "../../svgIcons/CreditRequestSvg";
import GlobalTableDropDown from "../../GlobalTableDropDown";
import { useGetAllProfessionsQuery } from "../../../../../store/admin/adminProfessions";
import { formatDate, formatTime } from "../../../../../utilities/utils";
import Loader from "../../../../commons/Loader";
import { Link } from "react-router-dom";
import SkeletonTable from "../../../../commons/Skeleton/SkeletonTable";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const ProfessionsToolTable = ({
  handleDropDownMenu,
  isEditId,
  setEditInputId,
}) => {
  const { data: allProfessions } = useGetAllProfessionsQuery();
  const navigate = useNavigate();
  const [showMenu, setShowMenu] = useState(null);
  const [professions, setProfessions] = useState();

  const showServices = (allServices, profession) => {
    const services =
      profession?.name === "Mental Health Counselor"
        ? profession?.professions?.map((service) => service.name)
        : allServices?.map((service) => service.name);

    if (!services || services.length === 0) return "No services available.";

    return services.length > 4
      ? `${services.slice(0, 4).join(", ")}, ...`
      : services.join(", ");
  };

  useEffect(() => {
    if (allProfessions) {
      setProfessions(allProfessions?.data);
    }
  }, [allProfessions]);

  useEffect(() => {
    window.addEventListener("click", () => {
      setShowMenu(false);
    });
    return () => {
      window.removeEventListener("click", () => {
        setShowMenu(false);
      });
    };
  }, []);

  const handleMenuItems = (userId, flag) => {
    if (!flag) {
      setShowMenu(userId.id);
    } else {
      setShowMenu(null);
    }
  };

  const handleServiceNavigation = (profession) => {
    navigate(`/admin-dashboard/admin-tools/${profession.id}`, {
      state: {
        profession: profession,
      },
    });
  };

  const handleInputChange = (e, profession) => {
    const tempProfessions = [...professions];
    const found = tempProfessions.findIndex(
      (item) => item.id === profession.id
    );
    if (found !== -1) {
      let oldObject = { ...tempProfessions[found] };
      oldObject["credit_cost"] = e.target.value;
      tempProfessions[found] = oldObject;
      setProfessions(tempProfessions);
    }
  };

  const handleClose = (e, profession) => {
    e.stopPropagation();
    setEditInputId(null);
    const tempProfessions = [...allProfessions?.data];
    const found = tempProfessions.findIndex(
      (item) => item.id === profession.id
    );
    if (found !== -1) {
      let oldObject = { ...tempProfessions[found] };
      tempProfessions[found] = oldObject;
      setProfessions(tempProfessions);
    }
  };

  return (
    <>
      {!allProfessions?.data ? (
        <SkeletonTable col={5} rows={5} />
      ) : (
        <div className="px-4 sm:px-6 lg:px-8 hidden md:block">
          <div className="mt-8 flow-root">
            <div className="table-scroller -mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8 bg-white border border-[#EBEFF3] rounded-md p-5">
              <div className="inline-block min-w-full py-2 align-middle">
                <div className="relative">
                  <table className="min-w-full table-fixed divide-y divide-gray-300">
                    <thead>
                      <tr>
                        <th
                          scope="col"
                          className="min-w-[3rem] py-3.5 pr-3 text-left text-sm font-bold text-[#485868]"
                        >
                          # ID
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-bold text-[#485868]"
                        >
                          Name
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-bold text-[#485868]"
                        >
                          Price per lead
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-bold text-[#485868]"
                        >
                          Services
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-bold text-[#485868]"
                        >
                          Created at
                        </th>
                        <th
                          scope="col"
                          className="relative py-3.5 pl-3 pr-4 sm:pr-0"
                        >
                          <span className="sr-only"></span>
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200 bg-white">
                      {professions &&
                        professions?.map((profession, index) => (
                          <tr
                            className="cursor-pointer hover:bg-[#EBF7FF]"
                            key={profession.id}
                            // onClick={() => handleServiceNavigation(profession)}
                          >
                              <Link
                                                          to={`/admin-dashboard/admin-tools/${profession.id}`}
                                                          state={
                                                            {profession: profession}
                                                          }
                                                          className="contents"
                                                        >
                            <td className="whitespace-nowrap px-3 py-4 text-sm text-customGray">
                              {profession.id}
                            </td>
                            <td
                              className={classNames(
                                "whitespace-nowrap py-4 pr-3 text-sm font-normal text-customGray"
                              )}
                            >
                              {profession.name}
                            </td>
                            <td className="whitespace-nowrap px-3 py-4 text-sm text-customGray">
                              <div className="flex items-center gap-3">
                                <div
                                  className={`h-9 rounded-md border border-[#EBEFF3] py-2 px-3 w-[96px] ${
                                    profession.id == isEditId
                                      ? "bg-white"
                                      : "bg-[#F1F4F6]"
                                  } flex items-center justify-center`}
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  <span className="data-base-svg w-[18px] h-[18px] mr-2.5">
                                    <CreditRequestSvg />
                                  </span>
                                  <input
                                    type="text"
                                    ref={(node) =>
                                      profession.id == isEditId && node?.focus()
                                    }
                                    value={profession.credit_cost}
                                    placeholder="100"
                                    onClick={(e) => e.stopPropagation()}
                                    disabled={profession.id != isEditId}
                                    onChange={(e) =>
                                      handleInputChange(e, profession)
                                    }
                                    className="bg-transparent text-sm font-normal leading-[140px] text-customGray border-l border-[#EBEFF3] pl-2.5 h-5"
                                  />
                                </div>
                                {profession?.id == isEditId && (
                                  <div className="flex items-center justify-center gap-2">
                                    <CheckCircleIcon
                                      className="w-6 h-6 text-[#16CA7C] cursor-pointer"
                                      onClick={(e) => e.stopPropagation()}
                                    />
                                    <XMarkIcon
                                      className="w-6 h-6 text-[#EF2121] cursor-pointer"
                                      onClick={(e) => {
                                        handleClose(e, profession);
                                      }}
                                    />
                                  </div>
                                )}
                              </div>
                            </td>
                            <td className="whitespace-nowrap px-3 py-4 text-sm text-customGray">
                              <div
                                className={`tooltip-icon services-tooltip relative inset-y-0 right-0 flex items-center h-6 my-auto cursor-pointer ${
                                  index < 3 ? "tooltip-below" : "tooltip-above"
                                }`}
                              >
                                <PencilSquareIcon className="w-5 h-5 text-primary mr-2" />
                                {showServices(
                                  profession?.professional_services,
                                  profession
                                )}
                                {profession?.professional_services?.length >
                                  0 && (
                                  <div
                                    className={`tooltip absolute left-0 ${
                                      index < 3 ? "top-8" : "bottom-8"
                                    } bg-primary rounded-md p-[10px] w-[250px] z-[2] invisible`}
                                  >
                                    {index < 3 ? (
                                      <>
                                        <div className="w-4 h-4 rotate-45 rounded-tl-[4px] bg-primary ml-[14px] mr-auto -mt-4"></div>
                                        <p
                                          className="text-xs font-medium leading-[160%] text-[#F1F4F6]"
                                          style={{ whiteSpace: "normal" }}
                                        >
                                          {profession?.name ===
                                          "Mental Health Counselor"
                                            ? profession?.professions
                                                ?.map((service) => service.name)
                                                .join(", ")
                                            : profession.professional_services
                                                ?.map((service) => service.name)
                                                .join(", ")}
                                        </p>
                                      </>
                                    ) : (
                                      <>
                                        <p
                                          className="text-xs font-medium leading-[160%] text-[#F1F4F6]"
                                          style={{ whiteSpace: "normal" }}
                                        >
                                          {profession?.name ===
                                          "Mental Health Counselor"
                                            ? profession?.professions
                                                ?.map((service) => service.name)
                                                .join(", ")
                                            : profession.professional_services
                                                ?.map((service) => service.name)
                                                .join(", ")}
                                        </p>
                                        <div className="w-4 h-4 rotate-45 rounded-tl-[4px] bg-primary mr-[14px] ml-auto -mb-4"></div>
                                      </>
                                    )}
                                  </div>
                                )}
                              </div>
                            </td>
                            <td className="whitespace-nowrap px-3 py-4 text-sm text-customGray">
                              {formatDate(profession.created_at)} &#8226;{" "}
                              {formatTime(profession.created_at)}
                            </td>
                            <td>
                              <GlobalTableDropDown
                                data={profession}
                                showMenu={showMenu === profession.id}
                                callBack={handleMenuItems}
                                isLastIndex={
                                  index == professionsToolTable.length - 2
                                }
                                menuItems={tableMenuItems}
                                handleDropDownMenu={(value, profession) => {
                                  setProfessions(allProfessions?.data);
                                  handleDropDownMenu(value, profession);
                                }}
                                setShowMenu={setShowMenu}
                              />
                            </td>
                            </Link>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="block md:hidden">
        <div>
          <ul>
            {professions &&
              professions?.map((profession, index) => (
                <li
                  className="border border-solid border-[#EBEFF3] rounded-md p-5 mb-[14px] flex justify-between bg-[#ffffff]"
                  onClick={() => handleServiceNavigation(profession)}
                >
                  <ul>
                    <li className="flex items-center mb-[14px] gap-[10px]">
                      <h6 className="w-[100px] text-sm font-bold leading-[160%] text-[#485868]">
                        # ID
                      </h6>
                      <span className="text-sm font-normal leading-[160%] text-customGray flex items-center gap-[6px]">
                        {profession.id}
                      </span>
                    </li>
                    <li className="flex items-center mb-[14px] gap-[10px]">
                      <h6 className="w-[100px] text-sm font-bold leading-[160%] text-[#485868]">
                        Name
                      </h6>
                      <span className="text-sm font-normal leading-[160%] text-customGray flex items-center gap-[6px]">
                        {profession.name}
                      </span>
                    </li>
                    <li className="flex items-center mb-[14px] gap-[10px]">
                      <h6 className="w-[100px] text-sm font-bold leading-[160%] text-[#485868]">
                        Price per lead
                      </h6>
                      <div className="flex items-center gap-3">
                        <div
                          className={`h-9 rounded-md border border-[#EBEFF3] py-2 px-3 w-[96px] ${
                            profession.id == isEditId
                              ? "bg-white"
                              : "bg-[#F1F4F6]"
                          } flex items-center justify-center`}
                          onClick={(e) => e.preventDefault()}
                        >
                          <span className="data-base-svg w-[18px] h-[18px] mr-2.5">
                            <CreditRequestSvg />
                          </span>
                          <input
                            type="text"
                            value={profession.credit_cost}
                            ref={(node) =>
                              profession.id == isEditId && node?.focus()
                            }
                            placeholder="100"
                            disabled={profession.id != isEditId}
                            onClick={(e) => e.stopPropagation()}
                            onChange={(e) => handleInputChange(e, profession)}
                            className="bg-transparent text-sm font-normal leading-[140px] text-customGray border-l border-[#EBEFF3] pl-2.5 h-5"
                          />
                        </div>
                        {profession.id == isEditId && (
                          <div className="flex items-center justify-center gap-2">
                            <CheckCircleIcon
                              className="w-6 h-6 text-[#16CA7C] cursor-pointer"
                              onClick={(e) => e.stopPropagation()}
                            />
                            <XMarkIcon
                              className="w-6 h-6 text-[#EF2121] cursor-pointer"
                              onClick={(e) => {
                                handleClose(e, profession);
                              }}
                            />
                          </div>
                        )}
                      </div>
                    </li>
                    <li
                      className="flex items-center mb-[14px] gap-[10px]"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <h6 className="w-[100px] text-sm font-bold leading-[160%] text-[#485868]">
                        Services
                      </h6>
                      <span className="text-sm font-normal leading-[160%] text-customGray flex items-center gap-[6px] w-[calc(100%-110px)]">
                        <div className="tooltip-icon services-tooltip relative inset-y-0 right-0 flex items-center my-auto cursor-pointer">
                          <PencilSquareIcon className="w-6 h-6 text-primary mr-2" />
                          <span className="w-[calc(100%-30px)]">
                            {showServices(profession.professional_services)}
                          </span>
                        </div>
                      </span>
                    </li>
                    <li className="flex items-center mb-[14px] gap-[10px]">
                      <h6 className="w-[100px] text-sm font-bold leading-[160%] text-[#485868]">
                        Created At
                      </h6>
                      <span className="text-sm font-normal leading-[160%] text-customGray flex items-center gap-[6px]">
                        {formatDate(profession.created_at)} &#8226;{" "}
                        {formatTime(profession.created_at)}
                      </span>
                    </li>
                  </ul>
                  <div>
                    <GlobalTableDropDown
                      data={profession}
                      showMenu={showMenu === profession.id}
                      callBack={handleMenuItems}
                      menuItems={tableMenuItems}
                      handleDropDownMenu={handleDropDownMenu}
                      setShowMenu={setShowMenu}
                    />
                  </div>
                </li>
              ))}
          </ul>
        </div>
      </div>
    </>
  );
};

export default ProfessionsToolTable;